import React from "react";

import { useTranslation } from "utils";

import { Flex, MainPage, Svg, Typography } from "components";

export const Offline = () => {
  const { t } = useTranslation(["meta"]);

  return (
    <MainPage pageName={"sign-in-up"} className="page splash padding-0">
      <section className="container">
        <Flex vertical align="center" justify="center" gap={32} className="mini-form full-height center">
          <Svg svgName="logos/klim_logo_brandmark_and_text_white" className="pulsating" />
          <Typography variant="h5" color="white">
            {t("errors.offline")}
          </Typography>
        </Flex>
      </section>
    </MainPage>
  );
};
